import { render, staticRenderFns } from "./Holidays.vue?vue&type=template&id=15353ddb&scoped=true"
import script from "./Holidays.vue?vue&type=script&lang=js"
export * from "./Holidays.vue?vue&type=script&lang=js"
import style0 from "./Holidays.vue?vue&type=style&index=0&id=15353ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15353ddb",
  null
  
)

export default component.exports